import { h } from 'preact';
import { useText } from 'preact-i18n';

const DotersProfile = ({
  name,
  lastName,
  userId,
  level,
  levelIcon,
  points,
  levelColor,
}) => {
  const { member_number, doters_points, you_are_level } = useText({
    member_number: 'label.member_number',
    you_are_level: 'label.you_are_level',
    doters_points: 'label.doters_points',
  });

  const levelToShow = levelColor.toLowerCase();

  const levelClassMapping = {
    gold: 'premium',
    silver: 'elite',
    green: 'basic',
  };

  const levelClass = levelClassMapping[levelToShow] || '';
  return (
    <div>
      <div className={`doters-${levelClass}-rectangle`}>
        <p className="text-l">
          {you_are_level} <b>{level}</b>
        </p>
      </div>
      <div className="doters-profile">
        <p className="text-xxl">
          <b>
            {name} {lastName}
          </b>
        </p>
        <p className="text-l">
          {member_number}: {userId}
        </p>
      </div>

      <div className="doters-points">
        <p className="text-xxxl">
          <b>
            {doters_points}: {points}
          </b>
        </p>
        <i className={`doters-${levelIcon}`} />
      </div>
    </div>
  );
};

export default DotersProfile;
